<!-- Mobile overlay -->
@if (isMobileOpen()) {
  <button id="private-sidebar-mobile-overlay" class="sidebar-overlay" (click)="closeMobileOverlay()" type="button" aria-label="Close sidebar overlay"></button>
}

<aside class="sidebar"
  [class.sidebar-expanded]="isExpanded()"
  [class.sidebar-collapsed]="!isExpanded()"
  [class.sidebar-mobile-open]="isMobileOpen()">

  <!-- Brand + toggle -->
  <div class="sidebar-header">
    @if (isExpanded()) {
      <div class="sidebar-brand">
        <img
          src="assets/icons/svg/caminhao_logo.svg"
          alt=""
          aria-hidden="true"
          class="sidebar-brand-logo"
        />
        <span class="sidebar-brand-name">{{ 'private.sidebar.brand' | translate }}</span>
      </div>
    }

    <button class="sidebar-toggle-btn" (click)="toggleSidebar()" id="btn-toggle-sidebar"
      [title]="(isExpanded() ? 'private.sidebar.collapse' : 'private.sidebar.expand') | translate">
      @if (isExpanded()) {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" id="icon-colapse-sidebar">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      } @else {
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" id="icon-expand-sidebar">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      }
    </button>

    <button class="sidebar-close-btn" (click)="closeMobileOverlay()" id="btn-close-sidebar" [title]="'private.sidebar.close' | translate">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- Menu -->
  <nav class="sidebar-nav">
    @for (item of visibleMenuItems(); track item.id) {

      @if (!item.children || item.children.length === 0) {
        <!-- Leaf item -->
        @if (item.id === 'sara') {
          <button class="nav-item"
            [id]="menuId(item.id)"
            type="button"
            (click)="onSaraClick()"
            (keydown.enter)="onSaraClick()"
            [title]="!isExpanded() ? (item.labelKey | translate) : ''">
            <span class="nav-icon">
              @if (item.materialIcon) {
                <span class="material-icons">{{ item.materialIcon }}</span>
              } @else if (item.icon) {
                <span [innerHTML]="item.icon"></span>
              }
            </span>
            @if (isExpanded()) {
              <span class="nav-label">{{ item.labelKey | translate }}</span>
            }
          </button>
        } @else {
          <a class="nav-item"
            [id]="menuId(item.id)"
            [routerLink]="item.route"
            routerLinkActive="nav-item-active"
            [routerLinkActiveOptions]="{ exact: !!item.routeExact }"
            (click)="closeOnMobile()"
            [title]="!isExpanded() ? (item.labelKey | translate) : ''">
            <span class="nav-icon">
              @if (item.materialIcon) {
                <span class="material-icons">{{ item.materialIcon }}</span>
              } @else if (item.icon) {
                <span [innerHTML]="item.icon"></span>
              }
              @if (item.badgeCount && item.badgeCount() > 0 && !isExpanded()) {
                <span class="nav-badge-dot" aria-hidden="true"></span>
              }
            </span>
            @if (isExpanded()) {
              <span class="nav-label">{{ item.labelKey | translate }}</span>
              @if (item.badgeCount && item.badgeCount() > 0) {
                <span class="nav-badge-count">{{ item.badgeCount() }}</span>
              }
            }
          </a>
        }

      } @else {
        <!-- Parent item with children -->
        <button class="nav-item nav-item-parent"
          [id]="menuId(item.id)"
          [class.nav-item-open]="isSubmenuOpen(item.id)"
          (click)="toggleSubmenu(item.id)"
          [title]="!isExpanded() ? (item.labelKey | translate) : ''">
          <span class="nav-icon">
            @if (item.materialIcon) {
              <span class="material-icons">{{ item.materialIcon }}</span>
            } @else if (item.icon) {
              <span [innerHTML]="item.icon"></span>
            }
          </span>
          @if (isExpanded()) {
            <span class="nav-label">{{ item.labelKey | translate }}</span>
            <span class="nav-chevron" [class.rotated]="isSubmenuOpen(item.id)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </span>
          }
        </button>

        @if (isExpanded() && isSubmenuOpen(item.id)) {
          <div class="submenu">
            @for (child of item.children; track child.id) {

              @if (!child.children || child.children.length === 0) {
                <!-- Leaf submenu item -->
                <a class="submenu-item"
                  [id]="menuId(child.id)"
                  [routerLink]="child.route"
                  routerLinkActive="submenu-item-active"
                  [routerLinkActiveOptions]="{ exact: !!child.routeExact }"
                  (click)="closeOnMobile()">
                  @if (child.materialIcon) {
                    <span class="submenu-icon">
                      <span class="material-icons">{{ child.materialIcon }}</span>
                    </span>
                  } @else if (child.icon) {
                    <span class="submenu-icon" [innerHTML]="child.icon"></span>
                  } @else {
                    <span class="submenu-dot"></span>
                  }
                  <span>{{ child.labelKey | translate }}</span>
                </a>

              } @else {
                <!-- Sub-group: expandable section within submenu -->
                <button class="submenu-group-btn"
                  [id]="menuId(child.id)"
                  [class.submenu-group-open]="isSubSubmenuOpen(child.id)"
                  (click)="toggleSubSubmenu(child.id)">
                  @if (child.materialIcon) {
                    <span class="submenu-icon">
                      <span class="material-icons">{{ child.materialIcon }}</span>
                    </span>
                  } @else {
                    <span class="submenu-dot"></span>
                  }
                  <span class="submenu-group-label">{{ child.labelKey | translate }}</span>
                  <span class="submenu-chevron" [class.rotated]="isSubSubmenuOpen(child.id)">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </button>

                @if (isSubSubmenuOpen(child.id)) {
                  <div class="sub-submenu">
                    @for (grandchild of child.children; track grandchild.id) {

                      @if (!grandchild.children || grandchild.children.length === 0) {
                        <a class="sub-submenu-item"
                          [id]="menuId(grandchild.id)"
                          [routerLink]="grandchild.route"
                          routerLinkActive="sub-submenu-item-active"
                          [routerLinkActiveOptions]="{ exact: !!grandchild.routeExact }"
                          (click)="closeOnMobile()">
                          @if (grandchild.materialIcon) {
                            <span class="submenu-icon">
                              <span class="material-icons">{{ grandchild.materialIcon }}</span>
                            </span>
                          } @else if (grandchild.icon) {
                            <span class="submenu-icon" [innerHTML]="grandchild.icon"></span>
                          } @else {
                            <span class="submenu-dot"></span>
                          }
                          <span>{{ grandchild.labelKey | translate }}</span>
                        </a>

                      } @else {
                        <!-- 4th level: expandable group inside sub-submenu -->
                        <button class="sub-submenu-group-btn"
                          [id]="menuId(grandchild.id)"
                          [class.sub-submenu-group-open]="isSubSubSubmenuOpen(grandchild.id)"
                          (click)="toggleSubSubSubmenu(grandchild.id)">
                          @if (grandchild.materialIcon) {
                            <span class="submenu-icon">
                              <span class="material-icons">{{ grandchild.materialIcon }}</span>
                            </span>
                          } @else {
                            <span class="submenu-dot"></span>
                          }
                          <span class="submenu-group-label">{{ grandchild.labelKey | translate }}</span>
                          <span class="submenu-chevron" [class.rotated]="isSubSubSubmenuOpen(grandchild.id)">
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                              <polyline points="6 9 12 15 18 9"/>
                            </svg>
                          </span>
                        </button>

                        @if (isSubSubSubmenuOpen(grandchild.id)) {
                          <div class="sub-sub-submenu">
                            @for (greatgrandchild of grandchild.children; track greatgrandchild.id) {
                              <a class="sub-sub-submenu-item"
                                [id]="menuId(greatgrandchild.id)"
                                [routerLink]="greatgrandchild.route"
                                routerLinkActive="sub-sub-submenu-item-active"
                                [routerLinkActiveOptions]="{ exact: !!greatgrandchild.routeExact }"
                                (click)="closeOnMobile()">
                                @if (greatgrandchild.materialIcon) {
                                  <span class="submenu-icon">
                                    <span class="material-icons">{{ greatgrandchild.materialIcon }}</span>
                                  </span>
                                } @else if (greatgrandchild.icon) {
                                  <span class="submenu-icon" [innerHTML]="greatgrandchild.icon"></span>
                                } @else {
                                  <span class="submenu-dot"></span>
                                }
                                <span>{{ greatgrandchild.labelKey | translate }}</span>
                              </a>
                            }
                          </div>
                        }
                      }

                    }
                  </div>
                }
              }

            }
          </div>
        }
      }
    }
  </nav>

  <!-- Footer: static link to the ANTT reference / legal policies page, always visible
       regardless of which page is open (see AB#102144) -->
  <div class="sidebar-footer">
    <a
      id="private-sidebar-policies-link"
      class="sidebar-footer-link"
      href="/app/politicas"
      target="_blank"
      rel="noopener"
      [title]="'private.sidebar.policies_link' | translate"
    >
      @if (isExpanded()) {
        <span>{{ 'private.sidebar.policies_link' | translate }}</span>
      } @else {
        <span class="material-icons sidebar-footer-icon">policy</span>
      }
    </a>
  </div>
</aside>
